import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { TICKET_STATUS_OPTIONS } from '../../constants/ticketStatuses';

export default function StatusFilter({ value = [], onChange }) {
  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel id="status-filter-label">Status</InputLabel>
      <Select
        labelId="status-filter-label"
        label="Status"
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selected) => (selected.length ? selected.join(', ') : 'All')}
      >
        {TICKET_STATUS_OPTIONS.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
